
    import has from 'lodash/has';
    import { mapState, mapActions } from 'vuex';
    import { ValidationObserver } from 'vee-validate';

    import Cookie from 'js-cookie';
    import ApplyPersonalInfo from '@/components/JobView/Apply/ApplyPersonalInfo';
    import C1Alert from '@/C1Components/C1Alert';
    import ApplyCoverLetter from '@/components/JobView/Apply/ApplyCoverLetter';
    import ApplyResume from '@/components/JobView/Apply/ApplyResume';
    import ApplyFormFooter from '@/components/JobView/Apply/ApplyFormFooter';
    import ApplyMixin from '@/components/JobView/Apply/ApplyMixin';

    export default {
        name: 'ApplyForm',

        components: {
            ValidationObserver,
            ApplyPersonalInfo,
            C1Alert,
            ApplyCoverLetter,
            ApplyResume,
            ApplyFormFooter,
        },

        mixins: [ApplyMixin],

        data() {
            return {
                response: {
                    status: '',
                    message: '',
                },
                loader: {
                    apply: false,
                },
            };
        },

        computed: {
            ...mapState({
                $_job: state => state.job.job,
                $_apiMessage: state => state.apiMessage,
                $_jobApplication: state => state.jobApplication,
            }),
        },

        methods: {
            ...mapActions('jobApplication', {
                $_applyToJob: 'applyToJob',
            }),

            async apply() {
                const validation = await this.$refs.formSeeker.validate();
                if (!validation) {
                    return false;
                }

                const data = {
                    token: this.$_job.token,
                    siteCode: this.$siteCode,
                    guest_email: (Cookie.get('guest_email') || ''),
                };

                if (this.$refs.personalInfo.firstName) {
                    data.first_name = this.$refs.personalInfo.firstName;
                }

                if (this.$refs.personalInfo.lastName) {
                    data.last_name = this.$refs.personalInfo.lastName;
                }

                if (this.$refs.personalInfo.contactNumber) {
                    data.contact_number = this.$refs.personalInfo.contactNumber;
                }

                // Set resume
                if (has(this.$refs.resume, 'selectedResume.id')) {
                    data.resume_id = this.$refs.resume.selectedResume.id;
                }

                // Set cover letter
                if (has(this.$refs.coverLetter, 'selectedCoverLetter.id')) {
                    data.cover_letter_id = this.$refs.coverLetter.selectedCoverLetter.id;
                }

                // Set resume review
                if (this.$_jobApplication.is_resume_review) {
                    data.top_resume = 1;
                }

                data.make_resume_default = this.$_jobApplication.make_resume_default;

                this.response.status = '';
                this.response.message = '';

                this.loader.apply = true;
                this.$_applyToJob({ jobUuid: this.$_job.uuid, data }).then((response) => {
                    this.afterApply(response.data);
                }).catch((error) => {
                    const errorCode = error.response.data.error;
                    this.response.status = 'yellow';
                    this.response.message = this.$_apiMessage[errorCode];
                    this.loader.apply = false;
                });
            },
        },
    };
